import { render } from "./wDateYear.vue?vue&type=template&id=5ca6991e&ts=true"
import script from "./wDateYear.vue?vue&type=script&lang=ts"
export * from "./wDateYear.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__